import { map as map_1, filter, empty, collect, singleton, length, tryPick, tail, head, isEmpty, exists, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { create, match } from "../fable_modules/fable-library-js.4.28.0/RegExp.js";
import { join, split, substring } from "../fable_modules/fable-library-js.4.28.0/String.js";
import { ParsedGuest } from "../Pages/Event/State.js";
import { item, equalsWith, map } from "../fable_modules/fable-library-js.4.28.0/Array.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";

const titles = ofArray(["Mr.", "Mrs.", "Ms.", "Dr.", "Prof.", "Sir", "Rev."]);

const listMarkerPattern = "^(\\d+[.\\)]\\s*|[-*•]\\s+)";

function isTitle(word) {
    return exists((t) => (t.toLowerCase() === word.toLowerCase()), titles);
}

function stripListMarker(line) {
    const m = match(create(listMarkerPattern), line);
    if (m != null) {
        return substring(line, m[0].length).trim();
    }
    else {
        return line.trim();
    }
}

/**
 * Parse a single name segment (no couple separator) into a ParsedGuest.
 * Handles: "First Last", "Last, First", "Title First Last", single names.
 */
export function parseNameSegment(segment) {
    const trimmed = segment.trim();
    if (trimmed === "") {
        return new ParsedGuest("", "", "", undefined, "", "");
    }
    else if (trimmed.indexOf(",") >= 0) {
        const parts = map((s) => s.trim(), split(trimmed, [","], undefined, 0));
        if (!equalsWith((x, y) => (x === y), parts, defaultOf()) && (parts.length === 2)) {
            const last = item(0, parts);
            const first = item(1, parts);
            const firstWords = ofArray(split(first, [" "], undefined, 0));
            let matchResult, rest_1, titleWord_1;
            if (!isEmpty(firstWords)) {
                if (isTitle(head(firstWords))) {
                    matchResult = 0;
                    rest_1 = tail(firstWords);
                    titleWord_1 = head(firstWords);
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return new ParsedGuest(join(" ", rest_1), last, titleWord_1, undefined, "", "");
                default:
                    return new ParsedGuest(first, last, "", undefined, "", "");
            }
        }
        else {
            return new ParsedGuest(trimmed, "", "", undefined, "", "");
        }
    }
    else {
        const words = ofArray(split(trimmed, [" "], undefined, 0));
        if (!isEmpty(words)) {
            if (isEmpty(tail(words))) {
                return new ParsedGuest(head(words), "", "", undefined, "", "");
            }
            else if (isTitle(head(words))) {
                if (!isEmpty(tail(words))) {
                    if (isEmpty(tail(tail(words)))) {
                        return new ParsedGuest(head(tail(words)), "", head(words), undefined, "", "");
                    }
                    else {
                        return new ParsedGuest(head(tail(words)), join(" ", tail(tail(words))), head(words), undefined, "", "");
                    }
                }
                else {
                    return new ParsedGuest("", "", head(words), undefined, "", "");
                }
            }
            else {
                return new ParsedGuest(head(words), join(" ", tail(words)), "", undefined, "", "");
            }
        }
        else {
            return new ParsedGuest("", "", "", undefined, "", "");
        }
    }
}

function splitCouple(line) {
    let testExpr;
    const parts = tryPick((sep) => {
        if (line.indexOf(sep) >= 0) {
            return split(line, [sep], undefined, 0);
        }
        else {
            return undefined;
        }
    }, ofArray([" & ", " and "]));
    let matchResult, left, right;
    if (parts != null) {
        if ((testExpr = parts, !equalsWith((x, y) => (x === y), testExpr, defaultOf()) && (testExpr.length === 2))) {
            matchResult = 0;
            left = item(0, parts);
            right = item(1, parts);
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const leftTrimmed = left.trim();
            const rightTrimmed = right.trim();
            const rightWords = ofArray(split(rightTrimmed, [" "], undefined, 0));
            const leftWords = ofArray(split(leftTrimmed, [" "], undefined, 0));
            if (length(rightWords) >= 2) {
                if (!isEmpty(leftWords) && (!isEmpty(tail(leftWords)) ? (isEmpty(tail(tail(leftWords))) && (isTitle(head(leftWords)))) : true)) {
                    const sharedLast = parseNameSegment(rightTrimmed).LastName;
                    if (sharedLast !== "") {
                        return ofArray([(leftTrimmed + " ") + sharedLast, rightTrimmed]);
                    }
                    else {
                        return ofArray([leftTrimmed, rightTrimmed]);
                    }
                }
                else {
                    return ofArray([leftTrimmed, rightTrimmed]);
                }
            }
            else {
                return ofArray([leftTrimmed, rightTrimmed]);
            }
        }
        default:
            return singleton(line);
    }
}

/**
 * Parse a full text block into a list of ParsedGuest records.
 * Handles multi-line input, list markers, couple separators, titles.
 */
export function parseText(text) {
    return collect((line) => {
        const cleaned = stripListMarker(line);
        if (cleaned === "") {
            return empty();
        }
        else {
            return filter((g) => {
                if (g.FirstName !== "") {
                    return true;
                }
                else {
                    return g.LastName !== "";
                }
            }, map_1(parseNameSegment, splitCouple(cleaned)));
        }
    }, ofArray(split(text, ["\n", "\r"], undefined, 1)));
}

/**
 * Swap first and last names for a ParsedGuest
 */
export function swapNames(guest) {
    return new ParsedGuest(guest.LastName, guest.FirstName, guest.Title, guest.Gender, guest.Tags, guest.Notes);
}

